import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  title: React.ReactNode;
  content: React.ReactNode;
  isOpen: boolean;
  onClick: () => void;
  className?: string;
  headerClassName?: string;
  contentClassName?: string;
}
export function AccordionItem({
  title,
  content,
  isOpen,
  onClick,
  className = '',
  headerClassName = '',
  contentClassName = ''
}: AccordionItemProps) {
  return <div className={`border border-white/10 rounded-xl overflow-hidden ${className}`} data-id="element-15">
      <button className={`w-full flex items-center justify-between p-4 text-left transition-colors hover:bg-white/5 ${headerClassName}`} onClick={onClick} aria-expanded={isOpen} data-id="element-16">
        <div className="flex-1" data-id="element-17">{title}</div>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="ml-4 flex-shrink-0" data-id="element-18">
          <ChevronDown className="w-5 h-5 text-brand-lilac" data-id="element-19" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-20">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-21">
            <div className={`p-4 pt-0 border-t border-white/10 ${contentClassName}`} data-id="element-22">
              {content}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
interface AccordionProps {
  items: {
    id: string;
    title: React.ReactNode;
    content: React.ReactNode;
  }[];
  defaultOpenId?: string;
  allowMultiple?: boolean;
  className?: string;
  itemClassName?: string;
  headerClassName?: string;
  contentClassName?: string;
}
export function Accordion({
  items,
  defaultOpenId,
  allowMultiple = false,
  className = '',
  itemClassName = '',
  headerClassName = '',
  contentClassName = ''
}: AccordionProps) {
  const [openIds, setOpenIds] = useState<Set<string>>(new Set(defaultOpenId ? [defaultOpenId] : []));
  const toggleItem = (id: string) => {
    setOpenIds(prev => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        if (!allowMultiple) {
          newSet.clear();
        }
        newSet.add(id);
      }
      return newSet;
    });
  };
  return <div className={`space-y-3 ${className}`} data-id="element-23">
      {items.map(item => <AccordionItem key={item.id} title={item.title} content={item.content} isOpen={openIds.has(item.id)} onClick={() => toggleItem(item.id)} className={itemClassName} headerClassName={headerClassName} contentClassName={contentClassName} data-id="element-24" />)}
    </div>;
}